module.exports = __webpack_public_path__ + "img/logo-essi-expert.d9aba153.svg";